































































































import { snakeCase } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../../logic/helpers/DrawerWidthMixin'
import ColorPicker from '../../../../ColorPicker/ColorPicker.vue'
import ConfigField from '../../../../ConfigField/ConfigField.vue'
import HelpMessage from '../../../../HelpMessage/HelpMessage.vue'
import CustomEditor from '../../logic/Editor/CustomEditor'
import CustomNode from '../../logic/Nodes/CustomNode'
import ErrorNodeSidebar from '../../logic/Nodes/SystemNodes/ui/ErrorNodeSidebar.vue'

@Component({
  methods: {
    snakeCase,
    isMobile,
  },
  components: {
    ConfigField,
    HelpMessage,
    ColorPicker,
  }
})
export default class FlowSidebar extends Mixins<DrawerWidthMixin>(DrawerWidthMixin) {
  @Prop() editor!: CustomEditor

  setNodeColorIsOpen = false

  handleClose() {
    if (this.editor) {
      this.editor.unselectNodes()
    }
  }

  get sidebarComponent(): typeof Vue | null {
    if (this.selectedNode) {
      if (this.selectedNode.name !== 'ERROR') {
        return this.editor.nodesBuilders[this.selectedNode.name].sidebarComponent
      }

      return ErrorNodeSidebar
    }

    return null
  }

  get selectedNode(): CustomNode | null {
    if (this.editor.selected.list.length) {
      return this.editor.selected.list[0]
    }
    return null
  }

  @Watch('editor.selected.list.length')
  change(selectedLength: number) {
    if (!selectedLength || selectedLength > 1) {
      this.editor.sidebarIsOpen = false
      this.setNodeColorIsOpen = false
    }
  }

  @Emit('setNodeColor')
  setNodeColor(color: string): { color: string, node: CustomNode } {
    this.setNodeColorIsOpen = false

    return { color, node: this.selectedNode! }
  }

  mounted() {
    this.initializeSidebarWidth(550)
  }
}
